import { TransitOperationFormValues } from 'features/declaration/models/schemas/transitOperationFormSchema'
import { toConsignmentSave } from '../models/mapper'
import { ConsignmentSave } from '../models/request'
import { Consignment } from '../models/types'
import { createConsignment } from '../api/createConsignment'
import { createConsignmentDraft } from '../api/createConsignmentDraft'
import { updateConsignment } from '../api/updateConsignment'
import { updateConsignmentDraft } from '../api/updateConsignmentDraft'

type SaveConsignmentProps = {
  transitOperationId: number
  consignmentId: number | null
  isDraft: boolean
  formValues: TransitOperationFormValues
  consignorId: number | null
  consigneeId: number | null
  carrierId: number | null
}

async function createOrUpdateConsignment(id: number | null, data: ConsignmentSave, isDraft: boolean): Promise<Consignment> {
  if (id != null) {
    return isDraft ? updateConsignmentDraft(id, data) : updateConsignment(id, data)
  }
  return isDraft ? createConsignmentDraft(data) : createConsignment(data)
}

function useConsignmentFormSubmit() {
  const saveConsignment = async ({
    transitOperationId,
    consignmentId,
    isDraft,
    formValues,
    consignorId,
    consigneeId,
    carrierId,
  }: SaveConsignmentProps) => {
    if (transitOperationId == null) throw Error('Missing transitOperationId')

    return createOrUpdateConsignment(consignmentId, toConsignmentSave(
      transitOperationId,
      formValues,
      consignorId,
      consigneeId,
      carrierId,
    ), isDraft)
  }

  return {
    saveConsignment,
  }
}

export default useConsignmentFormSubmit
